import { inject, Injectable } from '@angular/core';
import { map, Observable, of, take } from 'rxjs';
import { DataFilterDisplayService } from '../../../../interface';
import { CombinedCampaignSelectorService } from '../../../../../../../../data-services/combined-campaign-selector.service';

@Injectable({ providedIn: 'root' })
export class CampaignSelectorDisplayService implements DataFilterDisplayService {
  protected readonly campaignSelectorService = inject(CombinedCampaignSelectorService);

  getDisplay(value: any[]): Observable<string> {
    const campaignId = value?.[0];
    if (!campaignId) {
      return of('AUTOMATIONS.EDITOR.FILTERS.CAMPAIGN_DATA.INVALID_CAMPAIGN');
    }
    return this.campaignSelectorService.getMulti([campaignId]).pipe(
      take(1),
      map((campaigns) => {
        return campaigns[0].name;
      }),
    );
  }
}
